/**
 * HelpFooter Component - Shopify Sales Channel Requirement
 *
 * Required footer on every page of the embedded app.
 * Provides help links and support contact information.
 */

import React from 'react';
import { FooterHelp, Link } from '@shopify/polaris';

export default function HelpFooter() {
  return (
    <FooterHelp>
      Need help? Contact{' '}
      <Link url="mailto:support@inclub.vip" external>
        support@inclub.vip
      </Link>
    </FooterHelp>
  );
}
